import React, { FunctionComponent, memo } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CheckboxComponentProps } from './CheckboxComponent.types';

const CheckboxComponent: FunctionComponent<CheckboxComponentProps> = memo(
  props => {
    const {
      checked,
      checkBoxClassName,
      color = 'primary',
      disabled = false,
      handleChange = () => {},
      indeterminate = false,
      label,
      labelClassName,
      labelPlacement = 'end',
      name,
      value,
    } = props;
    return (
      <FormControlLabel
        className={labelClassName}
        control={
          <Checkbox
            className={checkBoxClassName}
            checked={checked}
            disabled={disabled}
            indeterminate={indeterminate}
            onChange={handleChange}
            name={name}
            color={color}
            value={value}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    );
  }
);

CheckboxComponent.displayName = 'CheckboxComponent';
CheckboxComponent.whyDidYouRender = true;
export { CheckboxComponent };
